export const policiesVersion = 2; //update this number when updating policies

export const TOS_MD =
  "https://app.euler.finance/terms"
export const PRIVACY_POLICY_MD =
  "https://app.euler.finance/privacy-policy"
export const RISK_DISCLOSURES_MD =
  "https://app.euler.finance/risk-disclosures"